import * as React from "react";
const SvgFiRrV = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-v_svg__a)">
      <path
        fill="#062147"
        d="M12 24.011c-1.872 0-3.46-1.083-4.144-2.825L.069 1.366a1 1 0 0 1 1.86-.732l7.788 19.82c.924 2.103 3.64 2.104 4.565 0L22.069.635a1 1 0 1 1 1.861.731l-7.787 19.82c-.684 1.742-2.272 2.825-4.144 2.825"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-v_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrV;
